


















































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Watch,
    Prop
} from "vue-property-decorator";
import {
    API_URL
} from "../global";
import {
    pageDataType,
    sociallinkItem,
    settinglinkItem,
    MainMenuItem,
    RmainMenuItem
} from "../types";
import HomePage from "./HomePage.vue";
import BasicPage from "./TeamBasicPage.vue";
import ContactPage from './ContactPage.vue';
import JobDetailsPage from './JobDetailsPage.vue';
import JobIndexPage from './Career.vue';
import NewsIndexPage from './NewsIndexPage.vue';
import NewsDetailPage from './NewsDetailPage.vue';
import DynamicLink from '../components/DynamicLink.vue';
import FullImgText from '../components/FullImgText.vue';

import {
    FETCH_MAIN_MENU,
    FETCH_RMAIN_MENU,
    FETCH_SOCIAL,
    FETCH_SETTING
} from "../store/actions.names";
import {
    pageData
} from '../store/pageData';

import {
    ADD_ANIMATION
} from "../store/mutations.names";

import {
    SET_PRELOADER_LOADED,
    SET_MENU_LOADED
} from "../store/mutations.names";
import axios from "axios";
import {
    TimelineMax,
    TweenLite,
    Power1,
    Power2,
    Cubic,
    Power4,
    TweenMax,
    Elastic,
    Linear,
    Back,
    SlowMo,
    Sine,
    Expo,
    Power3
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
import Footer from '../components/Footer.vue';

@Component({
    name: "Page",
    components: {
        HomePage,
        BasicPage,
        NewsIndexPage,
        NewsDetailPage,
        JobIndexPage,
        JobDetailsPage,
        ContactPage,
        DynamicLink,
        Footer
    },
    beforeRouteUpdate(to: any, from: any, next: any) {
        // console.log("updated");
        if ((this as any).mobileMenuIsActive == true) {
            (this as any).mobileMenuToggle();
            (this as any).MenuDestroy();

        }

        // for (var i = 0; i < activeLink.length; i++) {

        // }
        // for (var i = 0; i < activeLink.length; i++) {
        //     if (activeLink[i].classList.contains('router-link-exact-active router-link-active')) {
        //         //activeLink[i].parentElement.classList.add('js-hide');
        //         for (var num = 0; num < nlist.length; num++) {
        //             nlist.classList.add("active");
        //             // if (nlist[num].classList.contains('link router-link-exact-active router-link-active')) {
        //             //     nlist.classList.add("active");
        //             // }
        //         }

        //     }
        // }

        // link.classList.add("router-link");
        // activeLink() {
        //     setTimeout(() => {
        //         let d: any = document;
        //         var elem = d.querySelector('.mnlink');
        //         var link = d.querySelector('.link');
        //         var navlist = d.querySelectorAll('.navlist');
        //         if (elem.classList.contains('router-link-active')) {
        //             elem.classList.add('active');
        //         }
        //          if (link.classList.contains('router-link-active')) {
        //             link.classList.add('active');
        //         }
        //     }, 500)

        // }
        // let box = d.querySelector(".desktop");
        // box.classList.add("ds");
        // let child = d.querySelectorAll(".menu-wrap .has-child");
        // child.classList.add("ds");
        setTimeout(() => {
            (this as any).MenuDestroy();
        }, 2000)

        // let d: any = document;
        // let box = d.querySelector(".desktop");
        // let child = d.querySelector(".menu-wrap");
        // child.classList.add("ds");
        // // let childs = d.querySelectorAll(".has-children .texts");
        // // let childss = d.querySelector(".has-children .anim");
        // setTimeout(() => {
        //     box.classList.remove("ds");
        //     child.classList.add("ds");
        //     //    childs.style.display = 'none';
        //     // childss.style.display = 'none';
        // }, 5000)
        // (this as any).MenuDestroy();
        next();
    }
})
export default class Page extends Vue {
    @Getter("mainMenu") public mainMenu!: MainMenuItem[];
    @Getter("rmainMenu") public rmainMenu!: RmainMenuItem[];
    @Getter("sociallink") public sociallink!: sociallinkItem[];
    @Getter("settinglink") public settinglink!: settinglinkItem[];
    @Getter("pageData") public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_MAIN_MENU) public[FETCH_MAIN_MENU]: any;
    @Action(FETCH_RMAIN_MENU) public[FETCH_RMAIN_MENU]: any;
    @Action(FETCH_SOCIAL) public[FETCH_SOCIAL]: any;
    @Action(FETCH_SETTING) public[FETCH_SETTING]: any;

    @Mutation(SET_PRELOADER_LOADED) public[SET_PRELOADER_LOADED]: any;
    @Mutation(SET_MENU_LOADED) public[SET_MENU_LOADED]: any;

    @Getter("isPreloaderLoaded") public preloaderLoaded!: boolean;
    @Getter("isMenuLoaded") public MenuLoaded!: boolean;
    accordionIndex = 0;
    isDrop: boolean = false;
    isDrops: boolean = false;
    menuReady: boolean = false;
    ItemIndex: any | null = null;
    SubItemIndex: any | null = null;
    show: boolean = false;
    shown: boolean = false;
    isshow: boolean = false;
    showing: boolean = false;
    hover: boolean = false;
    isDropped: boolean = false;
    isActive: boolean = false;
    isDropdownActive: boolean = false;
    mobileMenuIsActive: boolean = false;
    mobileMenuTL: any | null = null;
    mobileNavTrail: any[] = [];
    sbIndex: any | null = null;
    childIndex: any | null = null;
    MenuIsActive: boolean = false;

    mbIndex(idx: any) {
         (this as any).sbIndex = idx;
    }
    mChildIndex(indx: any) {
        (this as any).childIndex = indx;
    }
    selectIndex(idx: any) {
        (this as any).ItemIndex = idx;
    }
    selectSubIndex(index: any) {
        (this as any).SubItemIndex = index;
       
        
    }
    // dropMenu(idx: any) {
    //     //  this.isDropdownActive = !this.isDropdownActive;
    //     (this as any).ItemIndex.idx == null;
    //     console.log('hoahdash');
    //     //   if(this.ItemIndex = idx){
    //     //       console.log('hoahdash');
    //     //   }
    //     // setTimeout(() => {
    //     //     this.ItemIndex.idx = null;

    //     // }, 1000);

    // }
    get pageTitle(): string {
        return this.pageData ? `${this.pageData.title} | TEAMGROUP` : "TEAMGROUP";
    }
    public goToPage(url: string) {
        this.$router.push(url);
    }

    @Watch("pageTitle")
    public handlePageTitleChange(val: any, oldVal: any) {
        document.title = val;
    }

    @Watch("preloaderLoaded")
    handlePreloaderLoaded(val: any, oldVal: any) {
        if (val && !this.MenuLoaded) {
            this.navanim();
        }
    }
    @Watch("PageData")
    public handlePageDataChange(val: any, oldVal: any) {}
    public handleScroll() {
        let scrollpos;
        let d: any = document;
        const nav = d.querySelector('.navbar');

        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;
            if (scrollpos > 30) {
                nav.classList.add('navbar-fixed');
                // nav.classList.remove('navbar-anim');

            } else {
                nav.classList.remove('navbar-fixed');
                // nav.classList.add('navbar-anim');
            }
        });

    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    public navanim() {
        var navanim = new TimelineMax({
            onComplete: () => {
                this[SET_MENU_LOADED](true)
            }
        });

        navanim
            .set(".navbar", {
                visibility: "visible"
            })
            .staggerFrom(
                ".navbar-brand",
                1, {
                    autoAlpha: 0,
                    yPercent: 40,
                    //delay: 5,
                    ease: Power2.easeOut,
                    clearProps: "all"
                }, .1, '-=.2'
            )
            .staggerFrom(
                ".main-nav .navlist",
                .4, {
                    autoAlpha: 0,
                    xPercent: 20,
                    ease: Power4.easeOut,
                    clearProps: "all"
                },
                0.1,
            );

    }

    // start mobile nav js

    // backwardToTrail() {
    //     const subMenu =
    //         (this.$refs.submenu as HTMLElement) ||
    //         document.querySelector(".content");
    //     this.mobileNavTrail.pop();
    //     if (this.mobileNavTrail.length === 0) {
    //         subMenu.classList.remove('add-menu');
    //     } else {
    //         subMenu.classList.add('add-menu');
    //     }
    // }

    // resetTrail() {
    //     const subMenu =
    //         (this.$refs.submenu as HTMLElement) ||
    //         document.querySelector(".content");
    //     this.$set(this, "mobileNavTrail", []);
    //     subMenu.classList.remove('add-menu');
    // }

    destroyIndex(idx: any) {
        (this as any).ItemIndex.idx == false;
    }
    MenuDestroy(evt: any | null = null) {
        if (evt != null) {
            evt.preventDefault()
        }
        let d: any = document;
        let box = d.querySelector(".desktop");
        box.classList.remove("ds");
        let nav = d.querySelector(".menu-wrap");
        nav.classList.add("ds");

    }

    pushToTrail(mitem: any, idx: number) {
        if (mitem.children) {
            this.mobileNavTrail.push(idx)
        }
    }

    get currentMenuLevel() {
        let val = (this as any).mainMenu;

        if (this.mobileNavTrail.length === 0) {
            return val;
        } else {
            for (const menuLevel of this.mobileNavTrail) {
                val = val[menuLevel].children;
            }
            return val;
        }
    }

    public mbmenu() {
        let d: any = document;
        let box = d.querySelector(".mbmenu");
        const {
            navlist
        } = this.$refs;
        let open = false;
        let tl = new TimelineMax({
            paused: true
        });
        tl.pause();
        tl.fromTo('.mbmenu', .5, {
            y: -2000,
            ease: Power4.easeOut,
        }, {
            yPercent: 0,
            clearProps: "all"
        }, 0.2)
        tl.staggerFrom(navlist, .2, {
            yPercent: 40,
            autoAlpha: 0,
            ease: Power4.easeOut,
            clearProps: "all"
        }, 0.1);

        this.mobileMenuTL = tl;
        // console.log(elements);
    }

    mobileMenuToggle(evt: any | null = null) {
        if (evt != null) {
            evt.preventDefault()
        }
        let d: any = document;
        let box = d.querySelector(".mbmenu");

        if (this.mobileMenuIsActive === false) {
            this.mobileMenuTL.play();
            box.classList.add("active-submenu");
        }
        if (this.mobileMenuIsActive === true) {
            this.mobileMenuTL.reverse();
            box.classList.remove("active-submenu");
        }
        this.mobileMenuIsActive = !this.mobileMenuIsActive;

    }

    mobileMenuNavigate(mitem: any, idx: number) {
        if (mitem.link === null) {
            if (mitem.children.length) {
                //  this.pushToTrail(mitem, idx);
                // this.addmenu();
            }
        } else {
            if (mitem.link.substring(0, 4).toLowerCase() == "http") {
                window.location.href = mitem.link
            } else {
                // setTimeout(() => {
                //     this.destroy();
                //     this.removemenu();
                // }, 300)
                this.$router.push(mitem.link)
            }

        }
    }
    // addActive() {
    //     let d: any = document;
    //     //var navlist = d.querySelector(".has-children");
    //     // var mnlink = d.querySelectorAll(".mnlink");

    //     var navlist =
    //         (this.$refs.navlist as HTMLElement) ||
    //         d.querySelector(".has-children");
    //     var mnlink =
    //         (this.$refs.mnlink as HTMLElement) ||
    //         d.querySelectorAll(".mnlink");
    //     for (var i = 0; i < mnlink.length; i++) {
    //         if (mnlink[i].classList.contains('router-link-exact-active router-link-active')) {
    //             navlist.classList.add("active");
    //         }
    //     }
    //     // if (mnlink.classList.contains('router-link-active')) {
    //     //     navlist.classList.add("active");
    //     // }
    // }

    //     //  var activeLink = d.querySelectorAll('.router-link-active');
    //     var activeLink = Array.from(d.querySelectorAll('.router-link-exact-active.router-link-active'))

    //     for (let element of activeLink) {
    //         if ((activeLink as any).classList.contains('router-link-exact-active router-link-active')) {
    //             nlist.classList.add('hover')
    //         }

    //     }

    // for (var i = 0; i < activeLink.length; i++) {
    //     if (activeLink[i].classList.contains('router-link-exact-active router-link-active')) {
    //         //activeLink[i].parentElement.classList.add('js-hide');
    //         for (var num = 0; num < nlist.length; num++) {
    //             nlist.classList.add("active");
    //             // if (nlist[num].classList.contains('link router-link-exact-active router-link-active')) {
    //             //     nlist.classList.add("active");
    //             // }
    //         }

    //     }
    // }
    //}
    // btnTechnology.addEventListener('click', showCategoryTechnology)

    //  let nlist = d.querySelectorAll(".link");

    // var nlink = d.querySelectorAll(".link");
    // var nlist = d.querySelectorAll(".navlist");
    //  if(document.querySelector("#target-element").classList.contains('current-post'))
    // for (var i = 0; i < nlink.length; i++) {
    // var elems = document.querySelectorAll('.link.router-link-exact-active.router-link-active')

    // if (nlink[i].classList.contains("router-link-active")) {

    //     nlist.classList.add("active");
    // }
    // }

    // }

    @Watch('menuReady')
    handleMenuReadyChange(val: boolean, oldVal: boolean) {
        if (val && (val != oldVal)) {
            this.$nextTick(() => {
                this.mbmenu();
            });
        }
    }

    preload(): void {

        let tl1 = new TimelineMax({
            onComplete: () => {
                this[SET_PRELOADER_LOADED](true);
            },
            paused: true
        });

        tl1

            .from(".loading-logo", .6, {
                autoAlpha: 0,
                y: 40,
                delay: 0.6,
                opacity: 0,
                visibility: "visible"
            })
            .from(".loaderlogo img", .8, {
                autoAlpha: 0,
                y: 40,
                scale: .7,
                ease: Power2.easeOut,
                opacity: 0
            })

            .fromTo(
                "#loodingwrap",
                1, {
                    background: "#E71C23",
                    opcity: .4,
                    xPercent: -100
                }, {
                    xPercent: 0,
                    clearProps: "all"
                }
            )
            .to("#loodingwrap", 0.1, {
                background: "#000000"
            })
            .from("path", .3, {
                autoAlpha: 0,
                opacity: 0

            }, "+=.2")
            .to(".loading", 1, {
                y: "-100%",
                ease: Power4.easeOut
            }, "-=.3");

        tl1.play();
    }

    mounted() {

        document.title = this.pageTitle;
        this[FETCH_MAIN_MENU]().then(() => {
            this[FETCH_RMAIN_MENU]().then(() => {
                this.menuReady = true;
            })
        })
        this[FETCH_SOCIAL]();
        this[FETCH_SETTING]();
        //this.addActive();
    }

}
